<template>
	<div class="settings-container">
		<div class="settings-content">
			<!-- 主要内容区域 -->
			<div class="main-content">
				<!-- 左侧标签页 -->
				<div class="tabs-section">
					<el-tabs v-model="activeTab" class="settings-tabs">
						<el-tab-pane name="process">
							<template #label>
								<span class="tab-label">
									<i class="el-icon-s-claim"></i>
									投保流程
								</span>
							</template>
							<div class="tab-content">
								<div class="tab-header">
									<h3>投保流程设置</h3>
									<el-button type="primary" size="small" @click="addProcessStep" class="add-btn">
										<i class="el-icon-plus"></i> 添加步骤
									</el-button>
								</div>
								<div class="process-steps-settings">
									<draggable v-model="processSteps" handle=".drag-handle">
										<div v-for="(step, index) in processSteps" :key="index" class="step-setting">
											<div class="step-header">
												<i class="el-icon-rank drag-handle"></i>
												<span class="step-number">步骤 {{ index + 1 }}</span>
												<el-button type="danger" size="mini" @click="removeProcessStep(index)"
													class="delete-btn">
													<i class="el-icon-delete"></i> 删除
												</el-button>
											</div>
											<div class="step-content">
												<el-input v-model="step.title" placeholder="步骤标题" class="step-title-input"></el-input>
												<el-input v-model="step.description" type="textarea" :rows="2" placeholder="步骤描述"
													class="step-desc-input"></el-input>
											</div>
										</div>
									</draggable>
								</div>
							</div>
						</el-tab-pane>

						<el-tab-pane name="guide">
							<template #label>
								<span class="tab-label">
									<i class="el-icon-guide"></i>
									投保指南
								</span>
							</template>
							<div class="tab-content">
								<div class="tab-header">
									<h3>投保指南设置</h3>
									<el-button type="primary" size="small" @click="addGuideItem" class="add-btn">
										<i class="el-icon-plus"></i> 添加指南
									</el-button>
								</div>
								<div class="guide-settings">
									<draggable v-model="guideItems" handle=".drag-handle">
										<div v-for="(item, index) in guideItems" :key="index" class="guide-setting">
											<div class="guide-header">
												<i class="el-icon-rank drag-handle"></i>
												<span class="guide-title">指南项 {{ index + 1 }}</span>
												<el-button type="danger" size="mini" @click="removeGuideItem(index)" class="delete-btn">
													<i class="el-icon-delete"></i> 删除
												</el-button>
											</div>
											<div class="guide-content">
												<div class="icon-selector">
													<span class="label">图标:</span>
													<el-select v-model="item.icon" placeholder="选择图标" size="small">
														<el-option v-for="icon in iconOptions" :key="icon.value" :label="icon.label"
															:value="icon.value">
															<i :class="icon.value"></i> {{ icon.label }}
														</el-option>
													</el-select>
												</div>
												<el-input v-model="item.title" placeholder="指南标题" class="guide-title-input"></el-input>
												<el-input v-model="item.description" type="textarea" :rows="2" placeholder="指南描述"
													class="guide-desc-input"></el-input>
											</div>
										</div>
									</draggable>
								</div>
							</div>
						</el-tab-pane>

						<el-tab-pane name="tips">
							<template #label>
								<span class="tab-label">
									<i class="el-icon-s-opportunity"></i>
									投保贴士
								</span>
							</template>
							<div class="tab-content">
								<div class="tab-header">
									<h3>投保贴士设置</h3>
									<el-button type="primary" size="small" @click="addTipItem" class="add-btn">
										<i class="el-icon-plus"></i> 添加贴士
									</el-button>
								</div>
								<div class="tips-settings">
									<draggable v-model="tipItems" handle=".drag-handle">
										<div v-for="(tip, index) in tipItems" :key="index" class="tip-setting">
											<div class="tip-header">
												<i class="el-icon-rank drag-handle"></i>
												<span class="tip-title">贴士 {{ index + 1 }}</span>
												<el-button type="danger" size="mini" @click="removeTipItem(index)" class="delete-btn">
													<i class="el-icon-delete"></i> 删除
												</el-button>
											</div>
											<div class="tip-content">
												<el-input v-model="tip.title" placeholder="贴士标题" class="tip-title-input"></el-input>
												<el-input v-model="tip.content" type="textarea" :rows="2" placeholder="贴士内容"
													class="tip-content-input"></el-input>
											</div>
										</div>
									</draggable>
								</div>
							</div>
						</el-tab-pane>
					</el-tabs>
				</div>

				<!-- 右侧操作按钮 -->
				<div class="action-section">
					<div class="action-card">
						<h3><i class="el-icon-s-operation"></i> 操作</h3>
						<div class="action-buttons">
							<el-button type="primary" @click="saveSettings" size="large" class="save-btn">
								<i class="el-icon-check"></i> 保存设置
							</el-button>
						</div>
						<div class="action-tips">
							<p><i class="el-icon-info"></i> 提示：拖拽可调整顺序</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import draggable from 'vuedraggable'

	export default {
		name: 'InsureGuideSettings',
		components: {
			draggable
		},
		data() {
			return {
				// 当前激活的标签页
				activeTab: 'process',
				// 投保流程数据
				processSteps: [],
				// 投保指南数据
				guideItems: [],
				// 投保贴士数据
				tipItems: [],
				// 图标选项
				iconOptions: [{
						value: 'el-icon-s-claim',
						label: '保险'
					},
					{
						value: 'el-icon-s-custom',
						label: '用户'
					},
					{
						value: 'el-icon-s-flag',
						label: '旗帜'
					},
					{
						value: 'el-icon-s-order',
						label: '订单'
					},
					{
						value: 'el-icon-s-opportunity',
						label: '机会'
					},
					{
						value: 'el-icon-s-help',
						label: '帮助'
					},
					{
						value: 'el-icon-s-promotion',
						label: '促销'
					},
					{
						value: 'el-icon-s-marketing',
						label: '营销'
					}
				]
			}
		},
		mounted() {
			this.getPageData();
		},
		methods: {
			// 添加流程步骤
			addProcessStep() {
				this.processSteps.push({
					title: '新步骤',
					description: '请填写步骤描述'
				})
			},

			// 删除流程步骤
			removeProcessStep(index) {
				this.processSteps.splice(index, 1)
			},

			// 添加指南项
			addGuideItem() {
				this.guideItems.push({
					icon: 'el-icon-s-claim',
					title: '新指南项',
					description: '请填写指南描述'
				})
			},

			// 删除指南项
			removeGuideItem(index) {
				this.guideItems.splice(index, 1)
			},

			// 添加贴士项
			addTipItem() {
				this.tipItems.push({
					title: '新贴士标题',
					content: '请填写贴士内容'
				})
			},

			// 删除贴士项
			removeTipItem(index) {
				this.tipItems.splice(index, 1)
			},
			
			getPageData(){
				this.$get('app-page-design/3').then(res=>{
					const data		  = res.data.content;
					this.processSteps = data.processSteps;
					this.guideItems   = data.guideItems;
					this.tipItems 	  = data.tipItems;
				}).catch(err=>{
					this.$message({
						message: err,
						type: 'warning'
					})
				});
			},

			// 保存设置
			saveSettings() {
				const data = {
					processSteps: this.processSteps,
					guideItems: this.guideItems,
					tipItems: this.tipItems
				};
				this.$put('app-page-design/3', {
					content: JSON.stringify(data)
				}).then(res=>{
					this.$message({
						message: '设置保存成功',
						type: 'success'
					})
				}).catch(err=>{
					this.$message({
						message: err,
						type: 'warning'
					})
				});
			},
		}
	}
</script>

<style lang="scss" scoped>
	.settings-container {
		padding: 20px;
		background-color: #f5f7fa;
		height: 100%;
		overflow-y: auto;
		box-sizing: border-box;
	}

	.settings-content {
		max-width: 1200px;
		margin: 0 auto;
		min-height: min-content;
	}

	// 主要内容区域
	.main-content {
		display: grid;
		grid-template-columns: 1fr 320px;
		gap: 24px;
		align-items: start;
	}

	// 标签页区域
	.tabs-section {
		background: white;
		border-radius: 12px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
		overflow: hidden;
	}

	.settings-tabs {
		::v-deep .el-tabs__header {
			background: #f8f9fa;
			margin: 0;
			padding: 0 24px;
			border-bottom: 1px solid #e8e8e8;
		}

		::v-deep .el-tabs__nav-wrap {
			&::after {
				display: none;
			}
		}

		::v-deep .el-tabs__item {
			font-weight: 500;
			padding: 0 32px;
			height: 60px;
			line-height: 60px;
			font-size: 15px;
			color: #666;
			transition: all 0.3s ease;
			position: relative;

			&.is-active {
				color: #5B8CFF;
			}

			&:hover {
				color: #5B8CFF;
			}
		}

		.tab-label {
			display: flex;
			align-items: center;
			gap: 8px;
			font-weight: 500;
		}
	}

	.tab-content {
		padding: 24px;
		min-height: 500px;
	}

	.tab-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 24px;
		padding-bottom: 16px;
		border-bottom: 1px solid #f0f0f0;

		h3 {
			margin: 0;
			color: #303133;
			font-size: 18px;
			font-weight: 600;
		}

		.add-btn {
			background: #5B8CFF;
			border-color: #5B8CFF;
			border-radius: 6px;
			font-weight: 500;
			
			&:hover {
				background: #4a7df5;
				border-color: #4a7df5;
			}
		}
	}

	// 操作按钮区域
	.action-section {
		position: sticky;
		top: 0;
	}

	.action-card {
		background: white;
		border-radius: 12px;
		padding: 24px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
		text-align: center;

		h3 {
			margin: 0 0 20px 0;
			color: #303133;
			font-size: 18px;
			font-weight: 600;
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 8px;
		}
	}

	.action-buttons {
		display: flex;
		flex-direction: column;
		gap: 12px;
		margin-bottom: 20px;
	}

	.save-btn {
		background: #5B8CFF;
		border-color: #5B8CFF;
		border-radius: 8px;
		height: 44px;
		font-weight: 500;
		box-shadow: 0 4px 12px rgba(91, 140, 255, 0.3);
		transition: all 0.3s ease;

		&:hover {
			background: #4a7df5;
			border-color: #4a7df5;
			transform: translateY(-2px);
			box-shadow: 0 6px 16px rgba(91, 140, 255, 0.4);
		}
	}

	.reset-btn, .preview-btn {
		border-radius: 8px;
		height: 44px;
		font-weight: 500;
		transition: all 0.3s ease;

		&:hover {
			transform: translateY(-2px);
		}
	}

	.action-tips {
		padding: 16px;
		background: #f8f9fa;
		border-radius: 8px;
		border-left: 4px solid #5B8CFF;

		p {
			margin: 0;
			color: #666;
			font-size: 14px;
			display: flex;
			align-items: center;
			gap: 8px;
		}
	}

	// 设置项样式优化
	.process-steps-settings,
	.guide-settings,
	.tips-settings {
		.step-setting,
		.guide-setting,
		.tip-setting {
			border: 1px solid #e8e8e8;
			border-radius: 8px;
			margin-bottom: 16px;
			overflow: hidden;
			transition: all 0.3s ease;
			background: white;

			&:hover {
				border-color: #5B8CFF;
				box-shadow: 0 2px 8px rgba(91, 140, 255, 0.1);
			}

			.step-header,
			.guide-header,
			.tip-header {
				display: flex;
				align-items: center;
				padding: 12px 16px;
				background: #f8f9fa;
				border-bottom: 1px solid #e8e8e8;

				.drag-handle {
					margin-right: 12px;
					color: #909399;
					cursor: move;
					font-size: 16px;
				}

				.step-number,
				.guide-title,
				.tip-title {
					flex: 1;
					font-weight: 500;
					color: #303133;
				}
			}

			.step-content,
			.guide-content,
			.tip-content {
				padding: 16px;

				.step-title-input,
				.guide-title-input,
				.tip-title-input {
					margin-bottom: 12px;
				}
			}
		}
	}

	.icon-selector {
		display: flex;
		align-items: center;
		margin-bottom: 12px;
		padding: 8px;
		background: #f8f9fa;
		border-radius: 6px;

		.label {
			margin-right: 12px;
			color: #606266;
			font-weight: 500;
			min-width: 40px;
		}
	}

	.delete-btn {
		margin-left: auto;
		border-radius: 4px;
	}

	// 响应式设计
	@media (max-width: 1024px) {
		.main-content {
			grid-template-columns: 1fr;
			gap: 20px;
		}

		.action-section {
			position: static;
		}

		.settings-tabs {
			::v-deep .el-tabs__item {
				padding: 0 20px;
			}
		}
	}

	@media (max-width: 768px) {
		.settings-container {
			padding: 12px;
		}

		.tab-content {
			padding: 16px;
		}

		.tab-header {
			flex-direction: column;
			gap: 12px;
			align-items: stretch;

			h3 {
				text-align: center;
			}
		}

		.action-buttons {
			gap: 8px;
		}

		.save-btn,
		.reset-btn,
		.preview-btn {
			height: 40px;
		}
	}
</style>